import * as ActionTypes from '../actions/ActionTypes';
import { findKnowledgeBaseByIdOrGetDefault } from '../knowledge-base/utils/findKnowledgeBaseByIdOrGetDefault';
import TemplateEditorNavigationContext from '../records/TemplateEditorNavigationContext';
const INITIAL_STATE = new TemplateEditorNavigationContext();
export default function templateEditorNavigationContext(state = INITIAL_STATE, {
  payload,
  type
}) {
  switch (type) {
    case ActionTypes.FETCH_KNOWLEDGE_BASE_SUCCESS:
      {
        const {
          requestedKnowledgeBaseId,
          knowledgeBases
        } = payload;
        const knowledgeBase = findKnowledgeBaseByIdOrGetDefault(knowledgeBases.objects, requestedKnowledgeBaseId);
        return state.set('selectedLanguage', knowledgeBase ? knowledgeBase.language : null);
      }
    case ActionTypes.TEMPLATE_EDITOR_SELECT_LANGUAGE:
      return state.set('selectedLanguage', payload);
    case ActionTypes.TEMPLATE_EDITOR_NAVIGATION_CONTEXT_CHANGE:
      return new TemplateEditorNavigationContext({
        navItemLabels: payload.navItemLabels,
        navItems: payload.navItems,
        previewPage: payload.previewPage,
        selectedLanguage: state.selectedLanguage,
        selectedNavItem: payload.selectedNavItem
      });
    default:
      return state;
  }
}